import type { FileView } from './searchParams';

/**
 * The ids binding the preview's tabs to the panel they swap.
 *
 * In a module of their own because the tabs live in `PreviewHeader` and the
 * panel in `PreviewPane`, and a component file that also exports constants
 * loses fast refresh.
 */
export const FILE_VIEW_PANEL_ID = 'file-view-panel';

export function viewTabId(view: FileView): string {
  return `file-view-tab-${view}`;
}
